import actionCreator from "../common/actionObjectCreator";

import submitData from "../common/postData";

export const actionDescriptor = "portfolio/";

const createAction = actionCreator(actionDescriptor);

const LOAD_PORTFOLIO = createAction("LOAD_PORTFOLIO");

export function loadPortfolio(portfolioId, regenerate) {
  var extra = "";

  if (regenerate) {
    extra = "/true";
  }

  return (dispatch) => {
    submitData(
      `Portfolio/${portfolioId}${portfolioId.indexOf("-") > 0 ? "/guid" : ""}${extra}`,
      { portfolioId },
      LOAD_PORTFOLIO,
      dispatch,
      true,
      {},
      "GET",
      true,
      1000,
    );
  };
}

export function loadPortfolioForDateRange(
  portfolioId,
  startMonth,
  startYear,
  endMonth,
  endYear,
) {
  return (dispatch) => {
    submitData(
      `PortfolioPartial/${portfolioId}${portfolioId.indexOf("-") > 0 ? "/guid" : ""}/${startMonth}/${startYear}/${endMonth}/${endYear}`,
      { portfolioId },
      LOAD_PORTFOLIO,
      dispatch,
      true,
      {},
      "GET",
      true,
      1000,
    );
  };
}

const defaultState = {
  loading: true,
  reportData: {},
  conclusions: {},
};

const reducer = (state = defaultState, action) => {
  var ret;

  switch (action.type) {
    case LOAD_PORTFOLIO.pending:
      ret = Object.assign({}, state, { loading: true, error: null });
      return ret;
    case LOAD_PORTFOLIO.fulfilled:
      ret = Object.assign({}, state, { loading: false }, action.payload);
      return ret;
    case LOAD_PORTFOLIO.rejected:
      ret = Object.assign({}, state, { loading: false, error: action.payload });
      return ret;
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/portfolio/portfolio.duck.js